import HTMLEmptyModal from "../HTMLModalComponent/HTMLEmptyModal"
import styles from "./modals.module.scss"
import SText from "../Text/SText"
import Input from "../input/Input"
import Button from "../Button/Button"
import { Field, Form, Formik } from "formik"
import * as Yup from "yup"
import { useMutateSubscribe } from "../../hooks/newsletter-hooks"
import { NEWSLETTERINTERESTED, NEWSLETTERPURPOSES } from "../../api/newsletter-api"
import { NewsletterSvg } from "../../svgs/NewsletterSvg"
import { useTranslations } from "next-intl"
import { sendMail } from "../../utils/sendMail"
import { log } from "next/dist/server/typescript/utils"

const newsletterValidationSchema = Yup.object().shape({
  email: Yup.string().email("Keine gültige E-Mail").required("Wir benötigen deine E-Mail"),
  name: Yup.string().required(),
})

const NewsletterModal = ({ isOpen, closeModal }: { isOpen: boolean; closeModal: () => void }) => {
  const mutateNewsletter = useMutateSubscribe()
  const t = useTranslations("doctors.waiting-list")
  const transForModal = useTranslations("index.contactarea")
  const initValues = {
    inputFake: "",
    email: "",
    name: "",
  }
  return (
    <HTMLEmptyModal
      isOpened={isOpen}
      onClose={closeModal}
      onProceed={() => null}
      innerModalCSS={styles.newsletterModal}
    >
      <div className={styles.imageGridContainer}>
        <NewsletterSvg
          style={{
            width: "288px",
            height: "auto",
          }}
        />
        {/*<Image*/}
        {/*  width={327}*/}
        {/*  height={280}*/}
        {/*  src={"/images/modal/studienteilnahme_img.webp"}*/}
        {/*  alt={"studienteilnahme bild"}*/}
        {/*  style={{*/}
        {/*    width: "100%",*/}
        {/*    height: "auto",*/}
        {/*  }}*/}
        {/*/>*/}
      </div>
      <div className={styles.newsletterContainerLeft}>
        <div className={styles.newsletterHeaderTextContainer}>
          <SText
            variant={"title"}
            size={16}
            style={{
              display: "block",
              marginBottom: "8px",
            }}
          >
            {t("sign-up")}
          </SText>
          <SText style={{ lineHeight: "160%" }} variant={"body"} color={"green400"} size={14}>
            {t("body")}
          </SText>
        </div>
        <div className={styles.studyCentersContainer}>
          <Formik
            validationSchema={newsletterValidationSchema}
            initialValues={initValues}
            onSubmit={
              (values: typeof initValues) => {
                console.log(values)
                sendMail(
                  {
                    name: values.name,
                    email: values.email,
                    message:
                      "This is a doctor, who wants to be" +
                      " contacted by us (through the newsletter" +
                      " modal on the doctors page)",
                    subject: "Doctors interest",
                  },
                  closeModal,
                  transForModal
                )
              }
              // mutateNewsletter.mutate(
              //   {
              //     name: values.inputFake,
              //     email: values.email,
              //     purposes: [NEWSLETTERPURPOSES.enum.WAITING_LIST],
              //     type: NEWSLETTERINTERESTED.enum.PATIENT,
              //     btype: values.name,
              //   },
              //   {
              //     onSuccess: () => closeModal(),
              //   }
              // )
            }
          >
            <Form style={{ width: "100%" }}>
              <SText variant={"label"} color={"green400"}>
                {"Name:"}
              </SText>
              <Field name="name">
                {({
                  field, // { name, value, onChange, onBlur }

                  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

                  meta,
                }) => (
                  <div style={{ marginBottom: "32px" }}>
                    <Input
                      {...field}
                      width={"full"}
                      aria-details={"Hier Namen eintragen"}
                      className={styles.input}
                      showEndAdornment={false}
                      variant={"underlined"}
                    />
                    {meta.touched && meta.error && (
                      <SText size={12} color={"r400"} variant={"error"}>
                        {"Wir benötigen deinen" + " Namen"}
                      </SText>
                    )}
                  </div>
                )}
              </Field>
              <SText variant={"label"} color={"green400"}>
                {"Email:"}
              </SText>
              <Field name="email">
                {({
                  field, // { name, value, onChange, onBlur }

                  form: { touched, errors }, // also values, setXXXX, handleXXXX, dirty, isValid, status, etc.

                  meta,
                }) => (
                  <div style={{ marginBottom: "32px" }}>
                    <Input
                      {...field}
                      width={"full"}
                      aria-details={"Hier Email eintragen"}
                      className={styles.input}
                      showEndAdornment={false}
                      variant={"underlined"}
                    />
                    {meta.touched && meta.error && (
                      <SText size={12} color={"r400"} variant={"error"}>
                        {meta.error}
                      </SText>
                    )}
                  </div>
                )}
              </Field>
              <Button type={"submit"} variant={"CTA"}>
                {t("send")}
              </Button>
            </Form>
          </Formik>
          {/*<Input value={""} type={"text"} onChange={() =>{}} variant={"underlined"}>Name</Input>*/}
          {/*<Input value={""} type={"email"} onChange={() =>{}} variant={"underlined"}>E-Mail</Input>*/}
        </div>
      </div>
    </HTMLEmptyModal>
  )
}

export default NewsletterModal
